import React from "react";
import ServiceDetail from "@/pages/services/ServiceDetail";

const RangeOven = () => <ServiceDetail slug="range-oven" />;
export default RangeOven;
